import { clsx } from 'clsx';
import { Drawer } from '@material-ui/core';

import { SFMainContent, SFMainDialogHeader } from './components';

import makeClasses from './SFMainDialog.style';

import type { OrderId } from 'shared/domain';
import type { DrawerProps } from '@material-ui/core';

export function SFMainDialog(props: Props) {
  const {
    orderId,
    fromChatBtn,
    classes,
    onBack = () => {},
    onClose,
    ...restProps
  } = props;

  const _classes = makeClasses();

  return (
    <Drawer
      anchor='right'
      elevation={0}
      onClose={onClose}
      ModalProps={{
        BackdropProps: {
          style: {
            opacity: 0.25,
          },
          classes: {
            root: _classes.backdropRoot,
          },
        },
      }}
      classes={{
        root: clsx(_classes.root, classes?.root),
        paper: clsx(_classes.paper, classes?.paper),
        ...{ classes },
      }}
      {...restProps}
    >
      <SFMainDialogHeader orderId={orderId} onBack={onBack} onClose={onClose} />
      <SFMainContent orderId={orderId} fromChatBtn={fromChatBtn} />
    </Drawer>
  );
}

interface Props extends DrawerProps {
  orderId: OrderId;
  fromChatBtn: boolean;
  onBack?: () => void;
}
